import React from "react"

type Props = {
    status: string
}

const StatusView = ({ status }: Props) => {
    const COMPLETED = "text-[#92FF24]"
    const PENDING = "text-[#DC9700]"
    const REJECTED = "text-[#F23838]"
    const style =
        status === "Success"
            ? COMPLETED
            : (status === "In Progress" || status === 'Pending')
                ? PENDING
                : REJECTED
    return (
        <div>
            <span className={`${style}`}>
                {status}
            </span>
        </div>
    )
}

export default StatusView
